import React from 'react';
import PropTypes from 'prop-types';
import StudioCard from '@fiverr-private/seller_card/src/StudioCard';
import ProfileCard from '../shared/ProfileCard';
import SafePureComponent from '../shared/SafePureComponent';
import { formatStudio } from '../../utils/studios';

const GigStudioCard = ({studio}) => {
    if (!studio) {
        return null;
    }

    const studioProps = formatStudio(studio);

    return (
        <ProfileCard>
            <StudioCard {...studioProps}/>
        </ProfileCard>
    );
};

GigStudioCard.propTypes = {
    studio: PropTypes.object
};

export { GigStudioCard };
export default SafePureComponent(GigStudioCard);
